import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  defaultContainer: {
    position: 'relative',
    height: '100%',
    width: '100%',
    overflowY: 'auto',
    padding: theme.spacing(2),
    paddingBottom: 100,
  },
  listContainer: {
    position: 'relative',
    height: '100%',
    width: '100%',
  },
  accordionResposta: {
    padding: theme.spacing(1),
  },
  containerPaginacao: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  botaoAdicionar: {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2),

  },
  filterActions: {
    marginTop: theme.spacing(2),
    display: 'flex',
    justifyContent: 'flex-end',
  },
}));